import React, { Component } from 'react';
import AuthService from '../utils/AuthService';

class CustomerInfo extends Component {
    constructor(props) {
        super(props);

        this.Auth = new AuthService();
    }

    render() {
      const { user } = this.props;

	  let province_name = user.province_abbreviation || user.province_name;

        return (
            <div className="pp-customer-info">
                <h3 className="pp-form-title">Submitted By</h3>
                <dl className="pp-info-piece">
                    <dt className="pp-label">Name</dt>
                    <dd className="pp-value">{user.first_name && user.first_name} {user.last_name && user.last_name}</dd>
                </dl>
                <dl className="pp-info-piece">
                    <dt className="pp-label">Company</dt>
                    <dd className="pp-value">{user.company}</dd>
                </dl>
                <dl className="pp-info-piece">
                    <dt className="pp-label">Phone</dt>
                    <dd className="pp-value">{user.phone}</dd>
                </dl>
                <dl className="pp-info-piece">
                    <dt className="pp-label">Address</dt>
                    <dd className="pp-value">
                        <address>
                            <p>{user.street_address}</p>
                            <p>{user.city && user.city + ','} {province_name} {user.postal_code}</p>
                        </address>
                    </dd>
                </dl>
            </div>
        );
    }
}

export default CustomerInfo;



// WEBPACK FOOTER //
// ./src/components/CustomerInfo.js